var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export var defaultConfig = {
    shouldIncludeAdminModule: true,
    apiBaseUrl: 'https://dev.staging.application.api.marktine.com/api',
    // apiBaseUrl: 'http://localhost:6300/api',
    // tokenKey:
    //   'localStorage.access' ||
    //   'cookie.vriti-dev-access-token' ||
    //   'cookie.vriti-sit-access-token' ||
    //   'cookie.vriti-production-access-token',
    tokenKey: 'localStorage.access',
    appIdentifier: 'a6ad46aa91d35d425ee2a5a424c65bcd9c18d1ba3d5fc029eb111be65255',
    customerSecretKey: '572d366bda2f3aec348d2a202c422b7ab451b4b9cc0995f87723e2544b3c',
    flowDropDown: {
        label: 'Select Interview Stage',
        placeholder: 'Select Interview Stage',
    },
};
var flowDropDown = defaultConfig.flowDropDown, restDefaultConfig = __rest(defaultConfig, ["flowDropDown"]);
export var defaultConfigForKanban = __assign(__assign({}, restDefaultConfig), { recruiterUrl: 'https://dev.staffing.vriti.ai', staffingUrl: 'https://dev.rec.vriti.ai', saveCandidateProfileApiUrl: 'https://dev.backend.vriti.ai/api/v2/recruiter/organization-saved-candidate/', candidateCard: {
        showMatchScore: true,
        showSkills: true,
        showStatusDropdown: true,
        showAppliedDate: true,
        showRelocation: true,
        showAIScheduledInterview: true,
        showPreferredWorkLocation: true,
        showLocationPreference: true,
        showJobType: true,
        showTimeAvailability: true,
        showNoticePeriod: true,
        showManualInterviewSchedule: true,
        showSalary: true,
        showGender: true,
        showExperience: true,
        showSaveOption: true,
        showShareOption: true,
        showEmailOption: true,
        showPhoneOption: true,
        showWhatsAppOption: true,
    } });
